import { gql } from '@apollo/client';

export default gql`
  mutation addOrder(
    $restaurantId: Float!
    $customerId: Float!
    $tableId: Float
    $deliveryType: String!
    $address: String
    $zipCode: String
    $orderTime: String
    $phoneNumber: String
  ) {
    postOrders(
      newOrderInput: {
        restaurantId: $restaurantId
        customerId: $customerId
        tableId: $tableId
        deliveryType: $deliveryType
        extraInfo: {
          address: $address
          zipCode: $zipCode
          orderTime: $orderTime
          phoneNumber: $phoneNumber
        }
      }
    ) {
      id
    }
  }
`;
